// Como uma nota de satisfação é escrita na tela — UMA definição para o card
// do topo e para as linhas por pergunta do relatório de CSAT. A régua vem do
// backend (Csat::ScaleRules): % de notas 4-5 em 1-5, média nas outras
// escalas.
//
// A média sai como se fala de nota ("7,5" de "/10", uma casa decimal) e não
// como "7,53 · média de 1 a 10": o número sozinho fazia o gestor parar para
// entender o que era.
// Vírgula decimal fixa, como o relatório já escrevia: a conta é BR.
const oneDecimal = value =>
  String(Math.round(Number(value) * 10) / 10).replace('.', ',');

export const formatCsatScore = ({ kind, value, max }, t) => {
  if (value === null || value === undefined) {
    return { main: '—', unit: '', hint: '' };
  }
  if (kind === 'percent_positive') {
    return {
      main: `${Math.round(value * 100)}%`,
      unit: '',
      hint: t('CSAT_REPORTS.SCORE.PERCENT_HINT'),
    };
  }
  return {
    main: oneDecimal(value),
    unit: `/${max}`,
    hint: t('CSAT_REPORTS.SCORE.AVERAGE_HINT'),
  };
};
